import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'
import PatientRegistrationForm from '../../components/PatientRegistrationForm'
import ImgBackground from '../../images/Vajira.jpg'
import { message } from 'antd'

const Container = styled.div`
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.52), rgba(0, 0, 0, 0.73)), url(${(props) => props.img});
  background-size: cover;
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: #f6f6f6;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
  
  @media (max-width: 768px) {
    padding: 10px;
    align-items: flex-start;
    padding-top: 20px;
  }
`

@inject('User')
@observer
class PatientRegistration extends React.Component {
    state = {
        hasSubmitted: false,
    }

    handleSubmit = (success) => {
        if (success) {
            message.success('ส่งคำขอสมัครสำเร็จ! เจ้าหน้าที่จะติดต่อกลับภายใน 1-3 วันทำการ')
            this.setState({ hasSubmitted: true })
        }
    }

    render() {
        const { hasSubmitted } = this.state
        return (
            <Container img={ImgBackground}>
                <PatientRegistrationForm
                    onSubmit={this.handleSubmit}
                    hasSubmitted={hasSubmitted}
                />
            </Container>
        )
    }
}

PatientRegistration.propTypes = {
    User: PropTypes.object,
}

PatientRegistration.defaultProps = {}

export default PatientRegistration
